import styled from 'styled-components';
import { getZindexByType } from '~/utils/style-utils.ts';

const AppBannerWrapper = styled.div`
	grid-area: appbanner;
	z-index: ${getZindexByType('app-banner')};
	width: 100%;
`;

export default AppBannerWrapper;
